import * as React from "react";

const ShareSvg = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={30}
    height={30}
    fill="var(--font-background)"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="none"
      stroke="var(--font-background)"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15.43 7.702c-7.88.296-11.99 7.53-13.26 11.694a.471.471 0 0 0 .461.604c.194 0 .37-.117.452-.293 2.959-6.286 9.624-7.392 12.431-7.143.244.022.42.232.42.477v2.084a.5.5 0 0 0 .848.358l3.916-3.805a.5.5 0 0 0 .064-.641L16.846 5.33a.5.5 0 0 0-.913.283v1.58a.518.518 0 0 1-.502.509Z"
    />
  </svg>
);
export default ShareSvg;
